import React, { useState, useCallback } from "react";

const useFilter = (filters=[]) => {
    
    const [activeFilters, setActiveFilters] = useState([...filters])

    const addFilter = useCallback((filter) => {
        setActiveFilters([...activeFilters, filter])
    }, [activeFilters])

    const removeFilter = useCallback((index) => {
        setActiveFilters(activeFilters.filter((filter, i) => i !== index))
    }, [activeFilters])

    const replaceFilter = useCallback((index, filter) => {
        let newActiveFilters = [...activeFilters]
        newActiveFilters[index] = filter;
        setActiveFilters(newActiveFilters)
    })
    
    const changeFilterValue = useCallback((key, value) => {
        let fIdx = activeFilters.findIndex(filter => Object.keys(filter)[0] === key)
        if (fIdx > -1) {
            activeFilters[fIdx] = {[key]: value}
            let newActiveFilters = [...activeFilters]
            setActiveFilters(newActiveFilters)
        }
    }, [activeFilters])

    const updateSearchFilter = useCallback((searchString) => {
        let newActiveFilters = activeFilters.filter((filter) => Object.keys(filter)[0] !== 'search')
        newActiveFilters.push({search:searchString})
        setActiveFilters(newActiveFilters)
    }, [activeFilters])

    return {
        activeFilters,
        addFilter,
        removeFilter,
        changeFilterValue,
        replaceFilter,
        updateSearchFilter
    }
}

export default useFilter